import styles from './Implant.module.scss';
import { Stack } from '../../../shared/ui/Stack/Stack';
import { Text } from '../../../shared/ui/Text/Text';


const Implant = () => {
    return ( 
        <div className={styles.xrayImg}>
        
            <Stack
                    direction = 'column'
                    gap = '32'
                    justifyContent='justifyCenter'
                    alignItems ='alignCenter'
                    className={styles.content}>
                <Text
                    size ='m'
                    className={styles.title}>
                        Как проходит имплантация в нашей клинике
                </Text>
                <Text
                    size ='m'
                    className={styles.par}>
                        Подготовка
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Возрастных ограничений для проведения дентальной имплантации 
                        практически не существует, имплантация проводится лицам с 
                        18 до 70 лет и старше, определяющим фактором её осуществления 
                        является  состояние здоровья пациента. 
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Перед имплантацией доктор обязательно проводит  
                        профессиональную гигиену полости рта, поскольку любой очаг 
                        инфекции в организме может привести к последующему отторжению
                        вживлённого имплантата.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Также доктор оценивает вашу пригодность для имплантатов, 
                        проверив общее состояние здоровья полости рта и плотность 
                        челюстной кости. В некоторых случаях, когда объем кости 
                        недостаточен, может потребоваться процедура, известная как 
                        костная пластика.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        После вашей первой консультации доктор составляет индивидуальный 
                        план лечения.
                </Text>
                <Text
                    size ='m'
                    className={styles.par}>
                        Имплантация
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Имплантат представляет собой винт, который во время хирургической 
                        операции вкручивается непосредственно в кость челюсти. 
                        Для того чтобы вкрутить имплантат в костную ткань необходимо 
                        разрезать десну и обнажить кость. Установка имплантата 
                        будет проводиться под местной анестезией, которая делает эту 
                        процедуру абсолютно безболезненной. После этого, используя 
                        специальные сверла и фрезы, в кости формируется отверстие строго 
                        определенного диаметра и строго определенной глубины, для того 
                        чтобы имплантат вкрутился в него с некоторым усилием и мог 
                        спокойно удерживаться, без каких либо микродвижений. 
                        После этого рана ушивается. Период заживления составляет 
                        приблизительно 3-6 месяцев.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        На втором этапе устанавливается формирователь десны. 
                        При этом создается правильный десневой контур, что улучшает 
                        гигиену ротовой полости. Смысл данной операции – создать прямой 
                        доступ к имплантату, также формирователь десны дополнительно 
                        расширят десну таким образом, чтобы готовая коронка выглядела 
                        как собственный зуб. Этот этап занимает еще 1-2 недели. 
                        Далее удаляется формирователь десны и устанавливается титановый 
                        абатмент, после чего начинается следующий этап лечения –
                        изготовление протезов. Таким образом, вся конструкция 
                        представляет собой некий разборный конструктор в виде:
                        имплантат – абатмент – коронка.
                </Text>
                <Text
                    size ='m'
                    className={styles.par}>
                        Последующий уход
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        При правильной гигиене грамотно установленный, качественный имплантат 
                        может служить не менее 25 лет. Самым важным фактором, влияющим на срок 
                        службы дентальных протезов, является соблюдение гигиены полости рта и 
                        регулярное посещение стоматолога. После проведения операции необходимы 
                        обязательные плановые осмотры у стоматолога — через 1, 3 и 7 месяцев. 
                        Врач сможет проверить функциональность вживлённого имплантата, 
                        состояние гигиены полости рта, наличие признаков воспаления или отторжения 
                        имплантата. Далее следует посещать стоматолога не реже двух раз в год 
                        для прохождения профилактического осмотра, проведения сеансов 
                        профессиональной гигиены полости рта и удаления потенциальных очагов 
                        развития инфекции в труднодоступных для зубной щетки местах.
                </Text>  
                <Text
                    size ='m'
                    className={styles.text}>
                        <span>В нашей клинике все хирургические манипуляции проводит профессиональный 
                        врач хирург-стоматолог-имплантолог, поэтому  возникновение осложнений 
                        сводится к минимуму.</span>
                </Text>               
            </Stack>
        </div>
    );
}

export default Implant;